import posthog from 'posthog-js';
import type { SurveyCallback } from 'posthog-js';

/**
 * Servicio centralizado para interactuar con PostHog.
 * Usar este servicio en lugar de importar la instancia de posthog directamente.
 */
export const postHogService = {
  capture: (event: string, properties?: Record<string, unknown>) => {
    posthog?.capture(event, properties);
  },

  identify: (userId: string, traits?: Record<string, unknown>) => {
    posthog?.identify(userId, traits);
  },

  reset: () => {
    posthog?.reset();
  },

  getSurveys: (callback: SurveyCallback, forceReload?: boolean) => {
    posthog?.getSurveys(callback, forceReload);
  },

  displaySurvey: (surveyId: string) => {
    posthog?.displaySurvey(surveyId);
  }
};
